import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CookieConsent from './parts/CookieConsent';
import LanguageSwitcher from './parts/LanguageSwitcher';
import { trackPageView } from '../utils/analytics';
import './Layout.css';
import './Layout.css';
import '../App.css';
import Footer from "./parts/Footer";

function Layout({ children, language }) {
  // Hook per accedere alle traduzioni
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const currentLang = language || i18n.language;

  // Stato per il menu mobile
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Force re-render when language prop changes
  useEffect(() => {
    // This effect ensures the Layout re-renders when language changes
    // The actual language change is handled by App.js
  }, [language]);

  // Track page views when location changes and user has consented to analytics
  useEffect(() => {
    const trackPage = () => {
      // Check if user has consented to analytics
      const cookieConsent = localStorage.getItem('cookieConsent');
      if (cookieConsent) {
        try {
          const preferences = JSON.parse(cookieConsent);
          if (preferences.analytics) {
            trackPageView(location.pathname);
          }
        } catch (e) {
          console.error('Error parsing cookie consent:', e);
        }
      }
    };

    // Track page after a small delay to ensure gtag is loaded
    const timeoutId = setTimeout(trackPage, 100);
    return () => clearTimeout(timeoutId);
  }, [location.pathname]);

  // Helper per generare link localizzati
  const localizedPath = (path) => {
    // path deve iniziare con /
    if (!path.startsWith('/')) path = '/' + path;
    // Sostituisci la lingua nella url
    const parts = location.pathname.split('/');
    if (['it', 'en', 'es', 'fr', 'de', 'pt'].includes(parts[1])) {
      parts[1] = currentLang;
      return parts.slice(0, 2).join('/') + path;
    } else {
      return '/' + currentLang + path;
    }
  };

  return (
      <div className="App text-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
              <header className="py-6 flex justify-between items-center">
                  <div className="flex items-center space-x-3">
                      <Link to={localizedPath('/')}>
                          <img alt="Seneca Today Logo" className="h-10 w-10 header-logo"
                               src="/img/logoBlack.png"/>
                      </Link>
                      <Link to={localizedPath('/')}>
                        <span className="text-2xl font-bold text-black">SENECATODAY.COM</span>
                      </Link>
                  </div>
                  <nav className="hidden md:flex space-x-8">
                      <Link to={localizedPath('/articles')} className="hover:text-[#003333] transition duration-300">{t('navigation.articles')}</Link>
                      <Link to={localizedPath('/mission')} className="hover:text-[#003333] transition duration-300">{t('navigation.mission')}</Link>
                      <Link to={localizedPath('/contact')} className="hover:text-[#003333] transition duration-300">{t('navigation.contact')}</Link>
                      <LanguageSwitcher />
                  </nav>
                  <button 
                      className="md:hidden"
                      onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                      aria-label="Toggle menu"
                  >
                      <span className="material-icons">{mobileMenuOpen ? 'close' : 'menu'}</span>
                  </button>
              </header>
              
              {/* Menu mobile */}
              {mobileMenuOpen && (
                  <nav className="md:hidden bg-gray-800 rounded-lg mb-4 p-4">
                      <div className="flex flex-col space-y-4">
                          <Link 
                              to={localizedPath('/articles')} 
                              className="hover:text-indigo-300 transition duration-300 py-2"
                              onClick={() => setMobileMenuOpen(false)}
                          >
                              {t('navigation.articles')}
                          </Link>
                          <Link 
                              to={localizedPath('/mission')} 
                              className="hover:text-indigo-300 transition duration-300 py-2"
                              onClick={() => setMobileMenuOpen(false)}
                          >
                              {t('navigation.mission')}
                          </Link>
                          <Link 
                              to={localizedPath('/contact')} 
                              className="hover:text-indigo-300 transition duration-300 py-2"
                              onClick={() => setMobileMenuOpen(false)}
                          >
                              {t('navigation.contact')}
                          </Link>
                          <div className="pt-2 border-t border-gray-700">
                              <LanguageSwitcher />
                          </div>
                      </div>
                  </nav>
              )}
              {/*<header className="App-header">*/}
              {/*    /!* Selettore di lingua *!/*/}
              {/*    <LanguageSwitcher/>*/}

              {/*    <div className="header-row">*/}
              {/*        <div className="profile-container">*/}
              {/*            <img src={process.env.PUBLIC_URL + '/seneca_profile.png'} alt="Seneca Profile"*/}
              {/*                 className="profile-image"/>*/}
              {/*        </div>*/}
              {/*        <div>*/}
              {/*            <h1 className="site-title"><span className="site-title-fist">Seneca</span><span*/}
              {/*                className="site-title-second">Today</span></h1>*/}
              {/*            <p style={{maxWidth: "400px"}}>{t('header.siteDescription')}</p>*/}
              {/*        </div>*/}
              {/*    </div>*/}
              {/*    <nav className="main-nav enhanced-nav">*/}
              {/*        <ul>*/}
              {/*            <li><Link to={localizedPath('/')} className="nav-link">{t('navigation.home')}</Link></li>*/}
              {/*            <li><Link to={localizedPath('/mission')} className="nav-link">{t('navigation.mission')}</Link>*/}
              {/*            </li>*/}
              {/*            <li><Link to={localizedPath('/characters')}*/}
              {/*                      className="nav-link">{t('navigation.characters')}</Link></li>*/}
              {/*        </ul>*/}
              {/*    </nav>*/}
              {/*</header>*/}

              <main className="App-main">
                  {children}
              </main>

              <Footer />

              {/* Cookie Consent Banner */}
              <CookieConsent/>
          </div>
      </div>
  );
}

export default Layout;
